module.exports = __webpack_public_path__ + "static/img/Pisces.9134ee0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Pisces.svg
// module id = 1401
// module chunks = 0